import React, { Component } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Header from '../components/HeaderNew';
import Footer from '../components/Footer';
import Contact from '../components/Contact';
import Homepage from '../components/Homepage';
import Signup from '../components/Signup';
import Login from '../components/Login';
import Cart from '../components/Cart';
import SearchBusiness from '../components/SearchBusiness';
import Profile from '../components/Profile';
import JoinUs from '../components/Signup/JoinUs';
import BusinessSignup from '../components/Signup/BusinessSignup';
import Authenticate from './Authenticate';
import AuthenticateAllow from './AuthenticateAllow';
import Logout from '../components/Login/Logout';
import 'react-toastify/dist/ReactToastify.css';
import News from '../components/News';
import SearchDeals from '../components/SearchDeals';
import BusinessPageNew from '../components/BusinessPageNew';

export default class Index extends Component {
    render() {
        return (
                <div className="index_wrapper" >
                    <Header />
                    <Routes>
                        <Route path='/business/:id' element={<AuthenticateAllow Component={<BusinessPageNew />} role='BUYER' />} />
                        <Route path='/businessnew/:id' element={<AuthenticateAllow Component={<BusinessPageNew />} role='BUYER' />} />
                        <Route path='/search' element={<SearchBusiness />} />
                        <Route path='/contact' element={<Contact />} />
                        <Route path='/products' element={<SearchBusiness />} />
                        <Route path='/strain' element={<Navigate to='/products' replace />} />
                        <Route path='/deals' element={<SearchDeals />} />
                        <Route path='/news' element={<News />} />
                        <Route path='/join' element={<JoinUs />} />
                        <Route path='/join/business' element={<BusinessSignup />} />
                        <Route path='/tour' element={<Navigate to='/join' replace />} />
                        <Route path='/signup' element={<Signup />} />
                        <Route path='/login' element={<Login />} />
                        <Route path='/cart' element={<AuthenticateAllow Component={<Cart />} role='BUYER' />} />
                        <Route path='/profile/*' element={<Authenticate Component={<Profile />} />} />
                        <Route path='/virginia' element={<SearchBusiness />} />
                        <Route path='/' element={<AuthenticateAllow Component={<Homepage />} role='BUYER' />} />
                        <Route path='/logout' element={<Logout />} />
                        <Route path='*' element={<Navigate to='/' replace />} />
                    </Routes>
                    <Footer />
                </div>
        );
    }
}
